import { takeLatest, call, put } from 'redux-saga/effects';
import get from 'lodash/get';
import CouponApiConstants from 'yoda-interfaces/lib/Coupon/CouponApiConstants';
import { getCouponTiles } from 'yoda-interfaces/lib/Coupon/CouponApi';
import { getCouponList } from 'yoda-interfaces/lib/CouponIRIS/CouponApi';
import * as CouponDetailsActionTypes from '../actionTypes/CouponDetailsActionTypes';
import { selectFeatureFlags } from '../selectors/ContextSelector';

function* CouponDetailsSaga() {
    try {
        const enableCMCouponfallback = get(selectFeatureFlags, 'enableCMCouponfallback', false);
        const { CM_COUPON_SERVICE_URL } = CouponApiConstants;

        const couponDetails = enableCMCouponfallback
            ? yield call(getCouponList, {
                  url: CM_COUPON_SERVICE_URL,
              })
            : yield call(getCouponTiles);

        yield put({ type: CouponDetailsActionTypes.COUPON_DETAILS_GET_SUCCESS, couponDetails });
    } catch (error) {
        yield put({ type: 'CONTENT_ERROR', error });
    }
}

const watchCouponDetailsSaga = function* watchCouponDetailsSaga() {
    yield takeLatest(CouponDetailsActionTypes.COUPON_DETAILS_GET_REQUEST, CouponDetailsSaga);
};

watchCouponDetailsSaga.sagaName = 'watchCouponDetailsSaga';

export default watchCouponDetailsSaga;
